import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';
import AppGate from './components/AppGate';
import AuthCallbackPage from './pages/AuthCallbackPage';
import { AuthProvider } from './contexts/AuthContext';
import { MuiTailwindProvider } from './providers/MuiTailwindProvider';
import './styles/tailwind.css';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MuiTailwindProvider>
      <HashRouter>
        <AuthProvider>
          <Routes>
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/*" element={<AppGate />} />
          </Routes>
        </AuthProvider>
      </HashRouter>
    </MuiTailwindProvider>
  </React.StrictMode>
);